<script>
    import PageBox from "../../layouts/PageBox.svelte";
    import ContentBox from "../../layouts/ContentBox.svelte";
    import Button from "../../ui_elements/Button.svelte";
    import SelectField from "../../ui_elements/SelectField.svelte";
    import InputField from "../../ui_elements/InputField.svelte";
    import { onMount } from "svelte";
    import { getData, post } from "../../utility.js";

    let categories = [];
    let subcategories = [];
    let questions = [];
    let questionTypes = [];
    let ready = false;

    let subcategory = "";
    let questionText = null;
    let questionType = null;

    let selected_category = undefined;

    // reset subcategory if category changes
    $: if (selected_category) {
        subcategory = "";
    }

    let information = "";
    let newQuestion = null;

    onMount(async () => {
        let data = await getData('get-data/?subcategories=all');
        subcategories = data.subcategories;
        data = await getData('get-data/?questions=all');
        questions = data.questions;
        data = await getData('get-data/');
        categories = data.categories;
        data = await getData('get-data/?question_types=all');
        questionTypes = data.question_types;
        ready = true;
    });

    const submitQuestion = async () => {
        try {
            const data = await post('create-question/', {
                subcategory: subcategory,
                question_type: questionType,
                question_text: questionText
            });
            console.log(data);

            newQuestion = { subcategory, questionType, questionText }

            subcategory = "";
            questionType = null;
            questionText = '';
        } catch (err) {
            information = err.message;
        }
    }

</script>
        
<PageBox pageTitle="Neue Frage erstellen">  

    <ContentBox>

        {#if information != ""}
        <div class="mb-4 p-4 bg-accent-light border border-accent-border text-accent-text rounded">
            {information}
        </div>            
        {/if}

        {#if newQuestion}
            <div class="mb-4 p-4 bg-accent2-background border border-accent2-border text-accent2-text rounded">
                <p>Der folgende Frage wurde erfolgreich erstellt:</p>
                <p>Fragentext: {newQuestion.questionText}</p>
                <p>Fragentyp: {newQuestion.questionType}</p>
                <p>Subkategorie: {newQuestion.subcategory}</p>
            </div>
        {/if}

        <div class="text-secondary-text font-bold mb-4">Neue Frage</div>
    
        {#if ready}
            <div class="flex items-start mb-4">      
                <div class="w-full">
                    <div class="flex mb-2">
                        <SelectField bind:value={selected_category} id="category" label="Kategorie">
                            <option value="" disabled selected>Kategorie auswählen</option>
                            {#each categories as category}
                                <option value={category.category_id}>{category.category_name}</option>
                            {/each}
                        </SelectField>
                        
                        <SelectField bind:value={questionType} id="questionType" label="Fragentyp">
                            <option value="" disabled selected>Fragentyp auswählen</option>
                            {#each questionTypes as questionTypeOption}
                                <option value={questionTypeOption.question_type_name}>{questionTypeOption.question_type_name}</option>
                            {/each}
                        </SelectField>
                    </div>
                </div>
            </div>

            <SelectField bind:value={subcategory} id="subcategory" label="Subkategorie" width="">
                <option value="" disabled selected>Subkategorie auswählen</option>
                {#each subcategories.filter(subcategory => subcategory.category_id === selected_category) as subcategoryOption}
                    <option value={subcategoryOption.subcategory_id}>{subcategoryOption.subcategory_name}</option>
                {/each}
            </SelectField>

            <InputField bind:value={questionText} id="questionText" label="Fragentext" placeholder="Fragentext" width="" />
            
            {#key subcategory}
                {#if subcategory !== ""}
                    Alle bestehenden Fragen der aktuell ausgewählten Subkategorie:
                    <ul> 
                        {#each questions.filter(p => p.subcategory_id == subcategory) as p}
                            <li>{p.question_text}</li>
                        {/each}
                    </ul>
                {/if}
            {/key}

        {/if}
        
        <Button on:click={submitQuestion} variant="submit">Neue Frage erstellen</Button>
    </ContentBox>

</PageBox>
